import { makeStyles } from "@material-ui/core/styles";
// import { alpha } from "@material-ui/core";
import { Colors, FONT_WEIGHT } from "../../helpers/theme";

const useStyles = makeStyles((theme) => ({
  authpages: {
    overflow: 'hidden',
    "& h2, & h1": {
      marginBottom: theme.spacing(2),
    },
    "& h1": {
      [theme.breakpoints.down("md")]: {
        marginBottom: theme.spacing(0),
      },
      [theme.breakpoints.down("sm")]: {
        paddingTop: theme.spacing(0),
      },
    },
    "& h2": {
      [theme.breakpoints.down("md")]: {
        marginBottom: "12px",
        fontSize: theme.typography.body1.fontSize,
        "& span": {
          fontSize: theme.typography.body1.fontSize,
        },
      },
    },
    "& .borderleft": {
      paddingTop: theme.spacing(7),
     // borderLeft: `1px solid ${alpha(theme.Colors.black, 0.1)}`,
      [theme.breakpoints.down("md")]: {
        paddingTop: theme.spacing(7),
        borderLeft: "0",
      },
      [theme.breakpoints.down("xs")]: {
        paddingTop: theme.spacing(0),
      },
      "&:last-child": {
        [theme.breakpoints.down("md")]: {
          paddingTop: theme.spacing(7),
        },
        [theme.breakpoints.down("sm")]: {
          paddingTop: theme.spacing(2),
        },
      },
    },
    "& .borderRight": {
      paddingTop: theme.spacing(7),
    //  borderRight: `1px solid ${alpha(theme.Colors.black, 0.1)}`,
      [theme.breakpoints.down("md")]: {
        borderRight: 0,
      },
      "&:last-child": {
        [theme.breakpoints.down("md")]: {
          paddingTop: theme.spacing(3),
        },
      },
    },
    "& .MuiButton-medium": {
      [theme.breakpoints.down("md")]: {
        minWidth: "100%",
      },
    },
    "& .validateEmailTextBox": {
      "& p.MuiTypography-body1": {
        color: Colors.darkSlate,
        "& span": {
          color: Colors.darkSlate,
        },
      },
      [theme.breakpoints.down("md")]: {
        marginBotom: "12px",
      },
    },
    "& .MuiButton-sizeLarge": {
      [theme.breakpoints.down("md")]: {
        minWidth: "100%",
      },
    },
    "& .imageAlign": {
      verticalAlign: "middle",
      marginRight: "12px",
    },
    "& .error-absolute": {
      "& p.Mui-error": {
        position: "absolute",
        bottom: "-25px",
      },
    },
    "& .btn-semi": {
      "& .MuiButton-medium": {
        minWidth: "177px",
        [theme.breakpoints.down("xs")]: {
          minWidth: "100%",
        },
      },
    },
    "& p": {
      "& br": {
        [theme.breakpoints.down("md")]: {
          display: "none",
        },
      },
    },
    '& .lg-container-width':{
      '& .MuiButton-root.MuiButton-medium':{
        minWidth: '192px',
        [theme.breakpoints.down("sm")]: {
          minWidth: '100%',
        },
      },
    },
    "& .container": {
      cursor: "text",
    },
    "& .character": {
      boxSizing:"border-box",
      height: '48px',
      padding:"12px 0px",
      fontFamily: theme.typography.fontFamily,
      lineHeight: theme.typography.body1.lineHeight,
      fontSize: theme.typography.body1.fontSize,
      color: Colors.black,
      border: " 1px solid #E3E6EC",
      borderRadius: "4px",
    },
    "& .characterInactive": {
      backgroundColor: Colors.white,
    },
  },
  
}));

export default useStyles;
